import React from "react";
import Subheading from "../Common/Subheading";
import EventsIcon from "../../assets/icons/Icon_Library/application icons/assets/events.svg2";
import NewFeature from "../Builder/Components/NewFeature";
import WhiteButtonsContainer from "../Common/WhiteButtonsContainer";
import HelpButton from "../HelpContent/HelpButton";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

function EventsReportingPage() {
  return (
    <div>
      <div>
        <NewFeature>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              <Subheading
                Icon={EventsIcon}
                heading="Events "
                subheading="See Asset data and asset events"
              />
            </div>
            <div className="d-flex justify-content-end">
              <WhiteButtonDropdown toggleHeading={"Actions"} toggleSubheading={"Events"} >
              <WhiteButtonsContainer
                buttons={[
                  {
                    icon: EventsIcon,
                    as: "RRLink",
                    heading: "Saved",
                     
                    subheading: "Reports",
                    to: "/assets/contacts/bulk",
                  },

                  {
                    as: "RRLink",
                    to: "/reporting/templates",
                    icon: EventsIcon,
                    heading: "Templates",
                    subheading: "Manage",
                  },
                ]}
              /></WhiteButtonDropdown>
            </div>
          </div>
          <div className="my-3"> table</div>
        </NewFeature>
      </div>
    </div>
  );
}

export default EventsReportingPage;
